import { FC, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';

// redux
import { Store } from '../../../redux/root';

// hooks
import { useCachedTotalOffers } from 'hooks/store';
import { useCachedTotalStatuses } from 'hooks/statuses';
import { useCachedTotalPlaceholders } from 'hooks/placeholders/usePlaceholders';

// components
import TabNavItem from 'shared/components/TabNav/TabNavItem';
import TabNav from 'shared/components/TabNav';

// types
import { MARKETING_TABS } from './types';

// styles
import styles from './MarketingContent.module.scss';

type StoreManagementTabsProps = {
	activeTab: MARKETING_TABS;
	// eslint-disable-next-line no-unused-vars
	setActiveTab: (tab: MARKETING_TABS) => void;
};

export const MarketingTabs: FC<StoreManagementTabsProps> = ({ activeTab, setActiveTab }) => {
	const history = useHistory();
	const location = useLocation();

	const statusesTotal = useCachedTotalStatuses();
	const challengesTotal = useSelector((store: Store) => store.challengeRedux.challengesTotal);
	const dailyQuotesTotal = useSelector((store: Store) => store.quotesRedux.quotesTotal);
	const placeholdersTotal = useCachedTotalPlaceholders();

	const offersTotal = useCachedTotalOffers();

	useEffect(() => {
		if (location.search.includes('statuses')) setActiveTab(MARKETING_TABS.Statuses);
		if (location.search.includes('challenges')) setActiveTab(MARKETING_TABS.CHALLENGES);
		if (location.search.includes('placeholders')) setActiveTab(MARKETING_TABS.PLACEHOLDERS);
		if (location.search.includes('daily-quotes')) setActiveTab(MARKETING_TABS.DAILY_QUOTES);
		if (location.search.includes('special-offer')) setActiveTab(MARKETING_TABS.SPECIAL_OFFER);
		if (location.search.includes('custom-push')) setActiveTab(MARKETING_TABS.CUSTOM_PUSH);
	}, [location.search]);

	useEffect(() => {
		if (!location.search) history.push({ search: '?store' });
	}, []);

	return (
		<TabNav>
			<TabNavItem
				parentClassName={styles.generateGroup}
				title={MARKETING_TABS.Statuses}
				activeTab={activeTab === MARKETING_TABS.Statuses}
				counter={statusesTotal}
				clickHandler={() => {
					history.push({ search: '?statuses' });
					setActiveTab(MARKETING_TABS.Statuses);
				}}
			/>
			<TabNavItem
				parentClassName={styles.generateGroup}
				title={MARKETING_TABS.CHALLENGES}
				activeTab={activeTab === MARKETING_TABS.CHALLENGES}
				counter={challengesTotal}
				clickHandler={() => {
					history.push({ search: '?challenges' });
					setActiveTab(MARKETING_TABS.CHALLENGES);
				}}
			/>
			<TabNavItem
				parentClassName={styles.generateGroup}
				title={MARKETING_TABS.PLACEHOLDERS}
				activeTab={activeTab === MARKETING_TABS.PLACEHOLDERS}
				counter={placeholdersTotal}
				clickHandler={() => {
					history.push({ search: '?placeholders' });
					setActiveTab(MARKETING_TABS.PLACEHOLDERS);
				}}
			/>
			<TabNavItem
				parentClassName={styles.generateGroup}
				title={MARKETING_TABS.DAILY_QUOTES}
				activeTab={activeTab === MARKETING_TABS.DAILY_QUOTES}
				counter={dailyQuotesTotal}
				clickHandler={() => {
					history.push({ search: '?daily-quotes' });
					setActiveTab(MARKETING_TABS.DAILY_QUOTES);
				}}
			/>
			<TabNavItem
				parentClassName={styles.generateGroup}
				title={MARKETING_TABS.SPECIAL_OFFER}
				activeTab={activeTab === MARKETING_TABS.SPECIAL_OFFER}
				counter={offersTotal}
				clickHandler={() => {
					history.push({ search: '?special-offer' });
					setActiveTab(MARKETING_TABS.SPECIAL_OFFER);
				}}
			/>
			<TabNavItem
				parentClassName={styles.generateGroup}
				title={MARKETING_TABS.CUSTOM_PUSH}
				activeTab={activeTab === MARKETING_TABS.CUSTOM_PUSH}
				clickHandler={() => {
					history.push({ search: '?custom-push' });
					setActiveTab(MARKETING_TABS.CUSTOM_PUSH);
				}}
			/>
		</TabNav>
	);
};
